import { logger } from '@src/utils/misc/logger';
import apptracker from '@src/utils/sensor/apptracker';
import { NEXA_DASHBOARD_LINK_CLICK } from '@src/utils/sensor/track';
import { HandlerOptions } from './types';

/**
 * Handles fetch_sessions_csv tool - opens user timeline dashboard in a new tab
 */
export const handleUserTimeline = (options: HandlerOptions): void => {
  try {
    const { args, baseUrl } = options;
    const { client_id, user_id, interval } = args || {};

    // Check for either client_id or userId
    if (!client_id && !user_id) {
      logger.error('Missing required client_id or userId for user timeline URL', { args });
      return;
    }

    // Build URL with either clientId or userId parameter
    const idParam = client_id ? `clientId=${client_id}` : `userId=${user_id}`;
    const baseUrlWithId = `${baseUrl}/dashboard/user-timeline/temp/1?${idParam}`;

    // Add interval if present
    const url = interval ? `${baseUrlWithId}&interval=${interval}` : baseUrlWithId;

    if (url) {
      window.open(url, '_blank');
      apptracker(NEXA_DASHBOARD_LINK_CLICK, { type: 'user_timeline', url });
      logger.log('Opened user timeline in new tab:', url);
    }
  } catch (error) {
    logger.error('Error handling user timeline:', error);
  }
};
